<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>分配新编号</el-breadcrumb-item>
      <el-breadcrumb-item>分配</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>

      <div class="projectList">
        <div>
          <span> 课题类别：</span>
          <el-select v-model="tempVar" @change="changeCategory" filterable allow-create default-first-option
            placeholder="请选择课题类别">
            <el-option v-for="item in projectCategorys" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="categorySon"> 课题方向：
          <el-select v-model="projectCategoryDirection" @change="changeCategoryDirection" filterable allow-create
            default-first-option placeholder="请选择课题方向">
            <el-option v-for="item in projectCategoryDirections" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <!-- 课题列表 -->
        <el-table :data="projectNeedEdit" style="margin-top:20px;">
          <el-table-column prop="name" label="课题名称" width="500"></el-table-column>
          <el-table-column prop="leader_name" label="课题作者" width="100"></el-table-column>
          <el-table-column prop="category" label="课题类别" width="300"></el-table-column>
          <el-table-column prop="category_direction" label="课题方向" width="200"></el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-edit" circle
                @click="editNewPid(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


    </el-card>

    <!-- 已分配信息 -->
    <el-card class="distributeTable">
      <el-table :data="projectNewPid" style="width: 100%">
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              @click="deleteItem(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="leader_name" label="作者" width="120"></el-table-column>
        <el-table-column prop="name" label="课题名称" width="580"></el-table-column>
        <el-table-column prop="new_name" label="课题新名称" width="380"></el-table-column>
        <el-table-column prop="new_pid" label="课题编号" width="120"></el-table-column>
        <el-table-column prop="category_direction" label="课题方向" width="180"></el-table-column>
      </el-table>
    </el-card>

    <!-- 对话框 -->
    <el-dialog title="分配新编号" :visible.sync="editVisible">
      <el-form :model="editForm" ref="editForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="pid" prop="pid">
          <el-input v-model="editForm.pid" disabled></el-input>
        </el-form-item>
        <el-form-item label="name" prop="name">
          <el-input v-model="editForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="leader">
          <el-input v-model="editForm.leader_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="新项目名称" prop="new_name">
          <el-input v-model="editForm.new_name"></el-input>
        </el-form-item>
        <el-form-item label="新项目编号" prop="new_pid">
          <el-input v-model="editForm.new_pid"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addNewPidButton()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tempVar: '',
      projectCategorys: [], //课题类别列表
      projectCategory: {}, //课题类别

      projectCategoryDirections: [],
      projectCategoryDirection: '', //选中的课题方向

      projectInfos: [],
      projectNewPid: [],
      projectNeedEdit: [],

      editVisible: false,
      editForm: {},

    }
  },
  created() {
    this.getProjectCategory()
  },
  methods: {

    // 获取课题类型
    async getProjectCategory() {
      const res1 = await this.axios.get(`/projectCategory`)
      if (res1.status === 200) {
        this.projectCategorys = res1.data.results
      } else {
        this.$message.warning("获取类型错误")
      }
    },

    //根据类型、方向，获取 projectNewPid、projectInfos
    async getInfos() {
      let url = ''
      let url1 = ''
      if (!this.projectCategoryDirection || this.projectCategoryDirection == '所有方向') {
        url = '/projectNewPid/?category=' + this.tempVar
        url1 = '/projectInfoLite/?category=' + this.tempVar
      } else {
        url = '/projectNewPid/?category=' + this.tempVar + '&category_direction=' + this.projectCategoryDirection
        url1 = '/projectInfoLite/?category=' + this.tempVar + '&category_direction=' + this.projectCategoryDirection
      }

      let res = await this.axios.get(url)
      if (res.status == 200) {
        this.projectNewPid = res.data.results
      } else {
        this.$message.warning('获取分配信息失败！')
      }
      let res1 = await this.axios.get(url1)
      if (res1.status == 200) {
        this.projectInfos = res1.data.results
      }
      else {
        this.$message.warning('获取课题信息失败！')
      }

      this.projectNeedEdit = []
      // 循环对比新pid表，没分配过的pid，添加到 projectNewPid
      for (let i = 0; i < this.projectInfos.length; i++) {
        let flag = false;
        for (let j = 0; j < this.projectNewPid.length; j++) {
          if (this.projectInfos[i].pid == this.projectNewPid[j].pid) {
            // console.log('pid', this.projectInfos[i].leader_name)
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.projectNeedEdit.push(this.projectInfos[i])
        }
      }
    },




    // 课题类别下拉框改变
    async changeCategory(event) {
      // 查找类别列表，定位类别
      const res1 = await this.axios.get(`/projectCategory/?name=${event}`)
      if (res1.status === 200) {
        this.projectCategory = res1.data.results[0]
      } else {
        this.$message.warning("获取类型错误")
      }
      // 判断课题方向是否为空
      if (this.projectCategory.direction == null || this.projectCategory.direction.data == null) {
        this.$message.warning(`课题方向为空，请先添加课题方向！`)
      }
      // 给方向下拉框赋值
      this.projectCategoryDirections = this.projectCategory.direction.data
      // 增加一行“所有方向”
      this.projectCategoryDirections.splice(0, 0, {
        name: '所有方向'
      })
      // 获取课题列表
      this.getInfos()
    },


    // 课题方向下拉框改变，获取课题列表
    async changeCategoryDirection(event) {
      //获取课题列表
      this.getInfos()
    },


    // 分配新pid
    editNewPid(item) {
      this.editVisible = true
      this.editForm = item

    },

    // 对话框确定按钮
    async addNewPidButton() {
      let data = {
        "pid": this.editForm.pid,
        "name": this.editForm.name,
        "leader": this.editForm.leader,
        "leader_name": this.editForm.leader_name,
        "category": this.editForm.category,
        "category_direction": this.editForm.category_direction,

        "new_pid": this.editForm.new_pid,
        "new_name": this.editForm.new_name,
      }
      let res = await this.axios.post('/projectNewPid/', data)
      if (res.status == 201) {
        this.$message.success('新增成功！')
        this.editVisible = false
        this.getInfos()
      }
      // 根据pid，查询projectInfo表的id
      let data1 = {}
      let res1 = await this.axios.get('/projectInfo/?pid=' + this.editForm.pid)
      if (res1.status == 200) {
        data1 = res1.data.results[0]
      }
      //根据id，修改projectInfo表，将name改成 this.editForm.new_name
      data1.new_name = this.editForm.new_name
      data1.new_pid = this.editForm.new_pid

      let res2 = await this.axios.put('/projectInfo/' + data1.id + '/', data1)
      if (res2.status == 200) {
        this.$message.success('修改成功！')
      }
    },



    // 删除
    async deleteItem(row) {
      // console.log('delete:', row)
      let resDel = await this.axios.delete('/projectNewPid/' + row.pid)
      if (resDel.status == 204) {
        this.$message.success('删除成功！')
      }
      // 修改new_pid、new_name为空
      let data1 = {}
      let res1 = await this.axios.get('/projectInfo/?pid=' + row.pid)
      if (res1.status == 200) {
        data1 = res1.data.results[0]
      }
      //根据id，修改projectInfo表，
      data1.new_pid = null
      data1.new_name = null
      let res2 = await this.axios.put('/projectInfo/' + data1.id + '/', data1)
      if (res2.status == 200) {
        this.$message.success('修改成功！')
      }

      this.getInfos()
    }
  }
}

</script>

<style lang='less'>
.el-breadcrumb {
  margin-bottom: 20px;
}

.categorySon {
  margin-top: 20px;
}

.assessorMajors {
  margin-top: 20px;
}

.distributeButton {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.distributeTable {
  margin-top: 10px;
}

.projectList {
  // border-right: 1px solid #999999;
}

.div-assessor {
  margin-top: 25px;
}

.div-coach {
  // border-top: 1px solid #999999;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectNewPid.vue